module.exports = __webpack_public_path__ + "static/media/aboutUs1.354123aa.jpg";